import { Box, Typography } from "@mui/joy";
import { ClassicyControlGroup } from "../../components/control-group/ClassicyControlGroup";
import "../styles/QuestionnaireSteps.css";

interface EmotionSelectionStepProps {
  selectedEmotions: string[];
  onToggle: (emotion: string) => void;
}

const EMOTIONS = [
  { name: "Excited", displayName: "Aufgeregt" },
  { name: "Nostalgic", displayName: "Nostalgisch" },
  { name: "Inspired", displayName: "Inspiriert" },
  { name: "Creative", displayName: "Kreativ" },
  { name: "Frustrated", displayName: "Frustriert" },
  { name: "Curious", displayName: "Neugierig" },
  { name: "Amazed", displayName: "Erstaunt" },
  { name: "Playful", displayName: "Verspielt" },
  { name: "Confident", displayName: "Selbstbewusst" },
];

function EmotionSelectionStep({
  selectedEmotions,
  onToggle,
}: EmotionSelectionStepProps) {
  return (
    <Box className="questionnaire-step">
      <Typography level="h2" sx={{ mb: 3, textAlign: "center" }}>
        Welche Emotionen hat er in dir geweckt?
      </Typography>
      <Typography level="h3" sx={{ mb: 3, textAlign: "center", opacity: 0.8 }}>
        Wähle alle zutreffenden aus
      </Typography>

      <ClassicyControlGroup
        label="Emotionen (mehrere auswählbar)"
        columns={false}
      >
        <Box className="option-grid">
          {EMOTIONS.map((emotion) => (
            <button
              key={emotion.name}
              className={`option-button ${selectedEmotions.includes(emotion.name) ? "selected" : ""}`}
              onClick={() => onToggle(emotion.name)}
            >
              {emotion.displayName}
            </button>
          ))}
        </Box>
      </ClassicyControlGroup>
    </Box>
  );
}

export default EmotionSelectionStep;
